import app from "nystem";
import { Wrapper } from "nystem-components";

const OverlayClose = ({ className, renderAs = "a", accessible, children }) => (
  <Wrapper renderAs={renderAs} className={className} accessible={accessible}
    onClick={(event) => {
      event.preventDefault();
      app.event("overlay", { do: "close" });
    }}>
    {children}
  </Wrapper>
);
export default OverlayClose;
